// extracted by mini-css-extract-plugin
export default {"tooltip":"SiteTooltip_tooltip__Rkh2L"};